import { render } from "./CardAttentionList.vue?vue&type=template&id=480f3f86"
import script from "./CardAttentionList.vue?vue&type=script&lang=js"
export * from "./CardAttentionList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__